// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .profile {
  background: linear-gradient(rgba(64, 71, 74, 0.63), rgba(64, 71, 74, 0.34));
  background-size: cover;
  padding: 50px 0 15px 18px;
  border-top: 0;
}
:host .name {
  color: #fff;
  font-size: 20px;
  margin-bottom: 5px;
  line-height: 110%;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AACE;EACE,2EAAA;EAGA,sBAAA;EACA,yBAAA;EACA,aAAA;AAFJ;AAKE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAHJ","sourcesContent":[":host {\n  .profile {\n    background: linear-gradient(rgba(64, 71, 74, 0.63), rgba(64, 71, 74, 0.34));\n    // url(../assets/images/profile/2.jpg) center no-repeat;\n\n    background-size: cover;\n    padding: 50px 0 15px 18px;\n    border-top: 0;\n  }\n\n  .name {\n    color: #fff;\n    font-size: 20px;\n    margin-bottom: 5px;\n    line-height: 110%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
